import { render, staticRenderFns } from "./addInpe.vue?vue&type=template&id=3949c48a"
import script from "./addInpe.vue?vue&type=script&lang=js"
export * from "./addInpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports